import { c as _c } from "react/compiler-runtime";
import { theme } from '@cc-shopping/ui/theme';
import { Box, type BoxProps, Slide, useMediaQuery } from '@mui/material';
import type { PropsWithChildren } from 'react';
import { useCompareContext } from '../../../Context';
import { MAXIMUM_COLUMNS_MOBILE, useCreditCardCompareColumnContext } from '../../ColumnContext';
type StickyHeaderContainerProps = BoxProps & {
  customDataTestId?: string;
};
export function StickyHeaderContainer(props) {
  const $ = _c(33);
  let additionalPropsContainer;
  let children;
  let customDataTestId;
  if ($[0] !== props) {
    ({
      customDataTestId,
      children,
      ...additionalPropsContainer
    } = props);
    $[0] = props;
    $[1] = additionalPropsContainer;
    $[2] = children;
    $[3] = customDataTestId;
  } else {
    additionalPropsContainer = $[1];
    children = $[2];
    customDataTestId = $[3];
  }
  const {
    showStickyHeader,
    stickyHeaderMinHeights
  } = useCompareContext();
  const {
    index
  } = useCreditCardCompareColumnContext();
  let t0;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = theme.breakpoints.down("md");
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const isMobile = useMediaQuery(t0);
  const t1 = index > MAXIMUM_COLUMNS_MOBILE - 1 ? "none" : "flex";
  let t2;
  if ($[5] !== t1) {
    t2 = {
      md: "flex",
      xs: t1
    };
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = `${stickyHeaderMinHeights.mobile}px`;
  const t4 = `${stickyHeaderMinHeights.desktop}px`;
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = {
      xs: t3,
      md: t4
    };
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = showStickyHeader ? `2px solid ${theme.palette.primary.main}` : 0;
  const t7 = showStickyHeader ? 1 : 0;
  let t8;
  if ($[10] !== t6 || $[11] !== t7) {
    t8 = {
      borderTop: t6,
      transition: "z-index 0.1s, opacity 0.1s ease-out",
      opacity: t7
    };
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = showStickyHeader ? 1 : -1;
  let t10;
  let t11;
  let t12;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      xs: null,
      md: 3
    };
    t11 = {
      xs: null,
      md: 1
    };
    t12 = {
      xs: 3,
      md: null
    };
    $[13] = t10;
    $[14] = t11;
    $[15] = t12;
  } else {
    t10 = $[13];
    t11 = $[14];
    t12 = $[15];
  }
  let t13;
  if ($[16] !== customDataTestId || $[17] !== index || $[18] !== isMobile) {
    t13 = !isMobile && {
      "data-testid": customDataTestId ?? `credit-card-compare-sticky-header-desktop-${index}`
    };
    $[16] = customDataTestId;
    $[17] = index;
    $[18] = isMobile;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== children || $[21] !== t13) {
    t14 = <Box px={t10} py={t11} p={t12} bgcolor="white" display="flex" justifyContent="space-between" flexDirection="column" flexGrow={1} {...t13}>{children}</Box>;
    $[20] = children;
    $[21] = t13;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== showStickyHeader || $[24] !== t14) {
    t15 = <Slide direction="down" in={showStickyHeader} mountOnEnter={true} timeout={100}>{t14}</Slide>;
    $[23] = showStickyHeader;
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== additionalPropsContainer || $[27] !== t15 || $[28] !== t2 || $[29] !== t5 || $[30] !== t8 || $[31] !== t9) {
    t16 = <Box display={t2} position="sticky" top={0} bgcolor="white" minHeight={t5} sx={t8} zIndex={t9} boxShadow={1} {...additionalPropsContainer}>{t15}</Box>;
    $[26] = additionalPropsContainer;
    $[27] = t15;
    $[28] = t2;
    $[29] = t5;
    $[30] = t8;
    $[31] = t9;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  return t16;
}